import React, { useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { Steps } from "./step-library"
import { useRoutingInfo } from "../../context/RoutingInfoContext"

const ViewName = Steps.WHERE_ARE_YOU_IN_JOURNEY_IVF_DECISION
export default function WhereAreYouInJourneyIVFDecisionStep(): JSX.Element {
  const { routingData } = useRoutingInfo()
  const journeyStageValue = routingData?.journeyStage
  const memberSelectsValue = ["STARTED_IUI_CYCLE", "STARTED_IVF_CYCLE"].includes(journeyStageValue)
    ? journeyStageValue
    : "OTHER_ANSWERS"

  const { setNextStep } = useStateMachine(ViewName, memberSelectsValue)
  useEffect(() => {
    setNextStep(ViewName, memberSelectsValue)
  })

  return <></>
}
